import { connect } from 'react-redux';
import { unhideComment } from '../Comment/redux/actionCreators';
import { isCommentReduxReady } from '../Comment/redux/selectors';
var mapStateToProps = function (state) { return ({
    isCommentReduxReady: isCommentReduxReady(state),
}); };
var mapDispatchToProps = {
    onUnhide: unhideComment,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=CommentDeleteNotification.container.js.map